import React from 'react'

import { Box } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'

import { tokenVar } from '../../theme/tokenVar'

const scanSweep = keyframes`
  0%, 33%   { top: 0%;   opacity: 0; }
  40%       { top: 8%;   opacity: 1; }
  80%       { top: 85%;  opacity: 1; }
  88%, 100% { top: 100%; opacity: 0; }
`

const rotateAndPulse = keyframes`
  0%, 22%   { transform: rotate(0deg)   scale(1);    }
  25%       { transform: rotate(90deg)  scale(1.2);  }
  33%, 47%  { transform: rotate(90deg)  scale(1);    }
  50%       { transform: rotate(180deg) scale(1.2);  }
  58%, 72%  { transform: rotate(180deg) scale(1);    }
  75%       { transform: rotate(270deg) scale(1.2);  }
  83%, 97%  { transform: rotate(270deg) scale(1);    }
  100%      { transform: rotate(360deg) scale(1);    }
`

export type GridTestingIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
}

export const GridTestingIcon = ({
  size = 18,
  color,
  colorScheme = 'dark',
}: GridTestingIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))

  return (
    <Box
      animation={`${rotateAndPulse} 12s ease-in-out infinite`}
      display='inline-flex'
      height={`${size}px`}
      overflow='hidden'
      position='relative'
      width={`${size}px`}
    >
      <svg
        fill='none'
        height={size}
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        viewBox='0 0 24 24'
        width={size}
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M6 2H2v4' />
        <path d='M18 2h4v4' />
        <path d='M6 22H2v-4' />
        <path d='M18 22h4v-4' />
      </svg>
      <Box
        animation={`${scanSweep} 3s ease-in-out infinite`}
        bg={resolvedColor}
        boxShadow={`0 0 4px ${resolvedColor}`}
        h='1px'
        left={0}
        pointerEvents='none'
        position='absolute'
        right={0}
      />
    </Box>
  )
}
